import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useCustomOverlay } from './useCustomOverlay';
export * from './useCustomOverlay';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    customOverlay,
    portal
  } = useCustomOverlay(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    customOverlay
  }), [customOverlay]);
  if (portal) {
    return portal;
  }
  return null;
});